export { default } from "app/core/components/errors/ErrorComponent"
